import { useContext, useEffect, useState } from "react";
import { LoginContext, MFA, PasswordValidation } from "../Login";
import APIContext from "../../hooks/API";
import { Saved } from ".";
import QRCode from "react-qr-code";
import { T } from "../traks";

const SecuritySettings = () => {
	const { user } = useContext(LoginContext);
	const { post } = useContext(APIContext);
	const [password, setPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [saved, setSaved] = useState(false);

	const IsValid = (pw) => {
		var passwordRegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
		var hasSpecialChar = /[',.<>?/:;{}@#%&*()_+\-=§±~!]+/;
		if (passwordRegExp.test(pw) && hasSpecialChar.test(pw)) {
			return true;
		} else {
			return false;
		}
	};
	const changePassword = () => {
		post({
			path: `/user/${user.agentId}`,
			args: { action: "updatePassword", arguments: { password, newPassword } },
		}).then((e) => {
			if (e.ok) {
				clearAll();
				setSaved(true);
			}
		});
	};

	const clearAll = () => {
		setPassword("");
		setNewPassword("");
		setConfirmPassword("");
	};
	if (!user) return;

	return (
		<div className="app-card">
			<div className="app-card-header">
				<T>Security</T>
			</div>
			<div className="app-card-body">
				<h5 className="section-heading">
					<T>Password</T>
				</h5>
				<p className="section-hint">
					<T>
						Passwords must consist of 8 characters and contain at least one
						lowercase, uppercase, numeric and special character.
					</T>
				</p>
				<div className="mb-3">
					<label htmlFor="sec-current-password" className="form-label">
						<T>Current password</T>
					</label>
					<input
						id="sec-current-password"
						name="current-password"
						type="password"
						autoComplete="current-password"
						placeholder="Current password"
						className="form-control"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label htmlFor="sec-new-password" className="form-label">
						<T>New password</T>
					</label>
					<input
						id="sec-new-password"
						name="new-password"
						type="password"
						autoComplete="new-password"
						placeholder="New password"
						className={`form-control ${
							!newPassword.length
								? ""
								: IsValid(newPassword)
								? "is-valid"
								: "is-invalid"
						}`}
						value={newPassword}
						onChange={(e) => setNewPassword(e.target.value)}
					/>
					<div className="invalid-feedback">
						<T>Invalid password!</T>
					</div>
				</div>
				<div className="mb-3">
					<label htmlFor="sec-confirm-password" className="form-label">
						<T>Confirm password</T>
					</label>
					<input
						id="sec-confirm-password"
						name="confirm-password"
						type="password"
						autoComplete="new-password"
						placeholder="Confirm new password"
						className={`form-control ${
							!confirmPassword.length
								? ""
								: newPassword === confirmPassword
								? "is-valid"
								: "is-invalid"
						}`}
						value={confirmPassword}
						onChange={(e) => setConfirmPassword(e.target.value)}
					/>
					<div className="invalid-feedback">
						<T>Passwords must match!</T>
					</div>
				</div>
				<div className="d-flex justify-content-end gap-2">
					<button
						disabled={
							password &&
							newPassword.length &&
							newPassword === confirmPassword
						}
						className="btn-cancel"
						onClick={clearAll}
					>
						<T>Cancel</T>
					</button>
					<button
						disabled={
							!(
								password &&
								newPassword.length &&
								newPassword === confirmPassword
							)
						}
						type="submit"
						className="btn-save"
						onClick={changePassword}
					>
						<Saved isSaved={saved} />
					</button>
				</div>

				<hr className="my-4" />
				<Enable2FA />
			</div>
		</div>
	);
};

const Enable2FA = () => {
	const [password, setPassword] = useState("");
	const [passwordIsValid, setPasswordIsValid] = useState(false);
	const [change, setChange] = useState(false);
	const [setupURL, setSetupURL] = useState("");
	const [mfaError, setMfaError] = useState("");
	const { post } = useContext(APIContext);
	const { user, useMFA: initialMFA } = useContext(LoginContext);
	const [useMFA, setUseMFA] = useState(initialMFA);

	useEffect(() => {
		if (passwordIsValid)
			post({
				path: `/login`,
				args: { password, MFA, agentId: user.agentId, dryrun: true },
			}).then((e) => {
				console.log({ passwordIsValid: e });
				setUseMFA(e.useMFA);
			});
	}, [password, passwordIsValid, post, user.agentId]);

	const handleSwitch = (e) => {
		setUseMFA(e.target.checked);
		if (e.target.checked) {
			post({
				path: `/user/${user.agentId}`,
				args: { action: "setupMFA" },
			}).then((e) => {
				setSetupURL(e);
			});
		} else {
			setSetupURL("");
			post({
				path: `/user/${user.agentId}`,
				args: { action: "disableMFA" },
			}).then((e) => {
				console.log("disable MFA:", e);
			});
		}
	};

	const verifyMFA = (MFA) => {
		setMfaError("");
		post({
			path: `/login`,
			args: { password, MFA, agentId: user.agentId, dryrun: true },
		}).then((e) => {
			if (e.validMFA) {
				setSetupURL();
			} else {
				setMfaError("Invalid verification code. Please try again.");
			}
		});
	};

	return (
		<div>
			<h5 className="section-heading">
				<T>Two-Factor Authentication</T>
			</h5>
			<p className="section-hint">
				<T>Use authenticator app to verify login.</T>
			</p>
			<button
				className={`btn ${change ? "btn-outline-secondary" : "btn-outline-primary"} btn-sm`}
				onClick={() => setChange((p) => !p)}
			>
				<T>{change ? "Close settings" : "Open settings"}</T>
			</button>
			{change && (
				<div className="mt-3">
					{!passwordIsValid && (
						<p className="text-danger mb-2" style={{ fontSize: "0.875rem" }}>
							<T>Please enter your password to continue</T>
						</p>
					)}
					<PasswordValidation
						{...{
							agentId: user.agentId,
							password,
							setPassword,
							passwordIsValid,
							setPasswordIsValid,
						}}
					/>
					{passwordIsValid && (
						<>
							<div className="form-check form-switch mt-3">
								<input
									checked={!!useMFA}
									className="form-check-input"
									type="checkbox"
									id="enable2fa-switch"
									onChange={handleSwitch}
								/>
								<label
									className="form-check-label"
									htmlFor="enable2fa-switch"
								>
									<T>2FA enabled</T>
								</label>
							</div>
							{setupURL ? (
								<div className="d-flex flex-column align-items-center mt-3">
									<h5 className="section-heading">
										<T>Scan the QR-code</T>
									</h5>
									<QRCode
										value={setupURL}
										title="Scan this with your authenticator app"
										size={180}
									/>
									<MFA
										onSubmit={verifyMFA}
										title="Enter the verification code to enable 2FA"
									/>
									{mfaError && (
										<p className="text-danger mt-2" style={{ fontSize: "0.875rem" }}>
											<T>{mfaError}</T>
										</p>
									)}
								</div>
							) : null}
						</>
					)}
				</div>
			)}
		</div>
	);
};

export default SecuritySettings;
